webpackJsonp([256851701801701],{

/***/ 558:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _marked = __webpack_require__(11);
	
	var _marked2 = _interopRequireDefault(_marked);
	
	var _gatsbyLink = __webpack_require__(5);
	
	var _CustomHelmet = __webpack_require__(7);
	
	var _CustomHelmet2 = _interopRequireDefault(_CustomHelmet);
	
	var _Hero = __webpack_require__(9);
	
	var _Hero2 = _interopRequireDefault(_Hero);
	
	var _Row = __webpack_require__(3);
	
	var _Row2 = _interopRequireDefault(_Row);
	
	var _Column = __webpack_require__(4);
	
	var _Column2 = _interopRequireDefault(_Column);
	
	var _Signup = __webpack_require__(64);
	
	var _Signup2 = _interopRequireDefault(_Signup);
	
	var _RFILightbox = __webpack_require__(68);
	
	var _RFILightbox2 = _interopRequireDefault(_RFILightbox);
	
	var _AdmissionsSignup = __webpack_require__(294);
	
	var _AdmissionsSignup2 = _interopRequireDefault(_AdmissionsSignup);
	
	var _Button = __webpack_require__(15);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var academyApplication = function (_React$Component) {
	    _inherits(academyApplication, _React$Component);
	
	    function academyApplication() {
	        _classCallCheck(this, academyApplication);
	
	        var _this = _possibleConstructorReturn(this, _React$Component.call(this));
	
	        _this.state = {
	            urlParamsSet: false,
	            urlParams: ''
	        };
	        return _this;
	    }
	
	    academyApplication.prototype.componentDidMount = function componentDidMount() {
	        var iFrame = this.refs.application;
	        var my_awesome_script = document.createElement('script');
	
	        my_awesome_script.setAttribute('src', 'https://tfaforms.com/js/iframe_resize_helper.js');
	
	        this.refs.resizeHandler.appendChild(my_awesome_script);
	
	        // document.body.classList.add('Academy-Application')
	    };
	
	    academyApplication.prototype.componentWillUnmount = function componentWillUnmount() {
	        // document.body.classList.remove('Academy-Application')
	    };
	
	    academyApplication.prototype.render = function render() {
	        var location = this.props.location;
	        // const page = this.props.data.page.edges[0].node
	
	        return _react2.default.createElement(
	            'div',
	            { id: 'destinations-quiz' },
	            _react2.default.createElement(
	                'div',
	                { id: 'logo', style: { position: 'absolute', top: '30px', left: '50px', zIndex: 900 } },
	                _react2.default.createElement('img', { src: '/images/redesign/global-citizen-year-new-logo.svg', alt: '' })
	            ),
	            _react2.default.createElement(_Hero2.default, {
	                title: 'Application'
	            }),
	            _react2.default.createElement(
	                _Row2.default,
	                { className: 'page-intro' },
	                _react2.default.createElement(
	                    _Column2.default,
	                    { width: '8', offsetL: '2', tablet: '12', className: 'text-center' },
	                    _react2.default.createElement(
	                        'h2',
	                        { className: 'h2' },
	                        'The application period is currently closed.'
	                    ),
	                    _react2.default.createElement(
	                        'p',
	                        null,
	                        'But you\u2019ll soon be able to apply to the Fall 2022 semester of Global Citizen Year Academy. Sign up below to learn more and be notified when our next round of applications opens!'
	                    ),
	                    _react2.default.createElement(_Button2.default, {
	                        text: 'Request Info',
	                        href: '/#signup',
	                        style: { marginTop: '30px' } }),
	                    _react2.default.createElement('div', { ref: 'resizeHandler' })
	                )
	            )
	        );
	    };
	
	    return academyApplication;
	}(_react2.default.Component);
	
	exports.default = academyApplication;
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-academy-apply-index-js-44b838d050678d5dd817.js